import { create } from "zustand";

const useTradesStore = create((set) => ({
  trades: [],
  tradeSymbols: [],
  latestTrades: {},
  totalTradesCount: 0,
  closedPositionsCount: 0,

  setTrades: (trades) => set({ trades }),
  setTradeSymbols: (symbols) => set({ tradeSymbols: symbols }),
  setLatestTrades: (latest) => set({ latestTrades: latest }),
  setTotalTradesCount: (count) => set({ totalTradesCount: count }),
  setClosedPositionsCount: (count) => set({ closedPositionsCount: count }),
}));

export default useTradesStore;
